// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('userData')
export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin' || userRole === 'client') return '/'
  //**-* OLD CODE
  //if (userRole === 'client') return '/access-control'
  //**-* NEW CODE
  if (userRole === 'client') return '/'
  return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})


//#region  *** DIRIGO CUSTOM FUNCTIONS ***
import { BackendUrl } from '@src/BackendUrl'
import axios from "axios"

//Check if user is logged in or if accesstoken is still valid
export const validateUser = async () => {
  console.log('validateUser run')
  const userData = localStorage.getItem('userData')
  const token = localStorage.getItem('accessToken')
  //alert(token)
  if (userData !== null && token !== null) {
    const validToken = await axios.post(`${BackendUrl()}/auth/verifyToken`, {token}) 
    return validToken !== null
  } else {
    return false
  }
}

//Get token from local storage
export const getToken = () => {
  const token = localStorage.getItem('accessToken')
  return token
}

//Handle errors based on status code from backend responses
export const handleResponseError = (error) => {

  if (error.response.status === 400) {
    //handle 400 error    
    if (error.response.data.message) return error.response.data.message
    else return 'Error 400: Bad Request'

  } else if (error.response.status === 401) {
    // handle 401 error
    return 'Token invalid or expired please login again'

  } else {
    // handle all other errors
    return error.message

  }
}

// ** Get Company Logo **
import DirigoLogo from '@src/assets/images/companylogos/Dirigo.svg'
import CoffeeLogo from '@src/assets/images/companylogos/CoffeeBarExperts.png'
import PFSLogo from '@src/assets/images/companylogos/PortoFiraSuites.png'
import LeCielLogo from '@src/assets/images/companylogos/LeCiel.png'
import HospitalityWayLogo from '@src/assets/images/companylogos/HospitalityWay.png'
import OiaDreamHousesLogo from '@src/assets/images/companylogos/CalderaHouses.png'
import AAPlanLogo from '@src/assets/images/companylogos/AAPlan_Logo.png'
import BBPlanLogo from '@src/assets/images/companylogos/BBPlan_Logo.png'
import AAJMLogo from '@src/assets/images/companylogos/AAJM_Logo.png'
import NobilityLogo from '@src/assets/images/companylogos/Nobility_Logo.png'
import HorizontesHotelLogo from '@src/assets/images/companylogos/HotelOrizontes.png'
import AquaMareLogo from '@src/assets/images/companylogos/AquaMare.png'
import ElealsLogo from '@src/assets/images/companylogos/ElealsHotel.png'
import EsmeLogo from '@src/assets/images/companylogos/ESME_Logo.png'
import AngsanaLogo from '@src/assets/images/companylogos/Angsana_Logo.png'
import MandarinCostaNavarinoLogo from '@src/assets/images/companylogos/Mandarin_Costa_Navarino_Logo.jpg'
import EnergodinamikiKefalinias from '@src/assets/images/companylogos/Energodinamiki.png'
import TzionasGroupLogo from '@src/assets/images/companylogos/TzionasLogo.png'
import DreamsHotelResortAndSpa from '@src/assets/images/companylogos/DreamsHotel_resort&spa.png'
import TheSummitEscapeLogo from '@src/assets/images/companylogos/TheSummitEscape.jpg'
import NoLogo from '@src/assets/images/companylogos/No_Logo_Company.png'

export const getCompanyLogo = companyId => {
  //Return logo based on company id in Softone
  switch (companyId) {
    case 1003 : 
      return AAPlanLogo
    case 1004 : 
      return BBPlanLogo
    case 3000 : 
      return EnergodinamikiKefalinias
    case 6001 : 
      return NobilityLogo
    case 9000 : 
      return DirigoLogo
    case 20182:
      return HospitalityWayLogo
    case 20184:
      return LeCielLogo
    case 20185:
      return OiaDreamHousesLogo
    case 20186:
      return PFSLogo
    case 20190:
      return TzionasGroupLogo
    case 20191:
      return AAJMLogo
    case 20194:
      return HorizontesHotelLogo
    case 20195:
      return ElealsLogo
    case 20196:
      return AquaMareLogo
    case 20221:
      return EsmeLogo
    case 20224:
      return AngsanaLogo
    case 20229:
      return TheSummitEscapeLogo
    case 20226:
      return MandarinCostaNavarinoLogo
    case 20230 :
      return DreamsHotelResortAndSpa
    case 30191:
      return CoffeeLogo
    default:
      return NoLogo
  }
}

//#endregion